import React from "react";
import { Box, Button, Divider, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { InputField } from "../../../../components/Form/InputField";
import { TextAreaField } from "../../../../components/Form/TextAreaField";
import { createPublicNotification } from "../../../../service/BuyerConfiguration/PublicNotifications/publicNotificationService";
import {
  notifyError,
  notifySuccess,
} from "../../../../components/ToastContainer/Toast/Toast";
import { TabConfig, FieldConfig } from "../Config/notificationFormConfig";
import { SystemAnnouncementFormValues } from "../../Types/BuyerConfigstype";
import { PromotionalAnnouncementFormValues } from "../../Types/BuyerConfigstype";

interface DynamicNotificationFormProps {
  config: TabConfig;
  initialValues: SystemAnnouncementFormValues | PromotionalAnnouncementFormValues;
  validationSchema: any;
  onSuccess?: () => void;
}

const DynamicNotificationForm: React.FC<DynamicNotificationFormProps> = ({
  config,
  initialValues,
  validationSchema,
  onSuccess,
}) => {
  const handleSubmit = async (
    values: any,
    { resetForm }: { resetForm: () => void }
  ) => {
    try {
      const payload = {
        ...values,
        type: config.type,
        data: config.type === "system"
          ? {
              maintenance_date: values.data.maintenance_date,
              start_time: values.data.start_time,
              end_time: values.data.end_time,
            }
          : {
              coupon_code: values.data.coupon_code,
              discount: Number(values.data.discount),
              url: values.data.url,
            },
      };

      const response = await createPublicNotification(payload);
      if (response.statusCode === 200 || response.statusCode === 201) {
        notifySuccess(
          response.data?.message ||
            `${config.label} created successfully`
        );
        resetForm();
        onSuccess?.();
      }
    } catch (error: any) {
      notifyError(
        error?.response?.data?.message ||
          `Failed to create ${config.label.toLowerCase()}`
      );
    }
  };

  const renderField = (field: FieldConfig, values: any) => {
    const commonProps = {
      label: field.label,
      name: field.name,
      isRequired: field.isRequired,
      placeholder: field.placeholder,
      ...field.inputProps,
    };

    switch (field.type) {
      case "textarea":
        return (
          <TextAreaField
            {...commonProps}
            rows={field.inputProps?.rows || 4}
          />
        );
      case "date":
        return <InputField {...commonProps} type="date" />;
      case "time":
        return <InputField {...commonProps} type="time" />;
      case "number":
        return (
          <InputField
            {...commonProps}
            type="number"
            min={field.inputProps?.min}
            max={field.inputProps?.max}
          />
        );
      case "url":
        return <InputField {...commonProps} type="url" />;
      default:
        return <InputField {...commonProps} />;
    }
  };

  // Separate image_url field (rendered separately)
  const imageField = config.fields.find((f) => f.name === "image_url");
  const otherFields = config.fields.filter((f) => f.name !== "image_url");

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { sm: "100%", md: "1700px" },
        height: "100%",
      }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, resetForm }) => {
        //   const handleReset = () => {
        //     resetForm();
        //   };

          return (
            <Form>
              {imageField && (
                <>
                  <Box sx={{ p: 2, mb: 2, backgroundColor: "#fafafa", borderRadius: 1 }}>
                    {renderField(imageField, values)}
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                </>
              )}
              <Box sx={{ display: "flex", gap: 2 }}>
                <Grid container columns={12} spacing={2} alignItems="flex-start">
                  {otherFields.map((field, index) => (
                    <Grid
                      key={index}
                      item
                      xs={field.gridProps?.xs || 12}
                      md={field.gridProps?.md || 12}
                    >
                      {renderField(field, values)}
                    </Grid>
                  ))}
                </Grid>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: 3,
                  gap: 2,
                }}
              >
                {/* <Button
                  type="button"
                  variant="outlined"
                  color="primary"
                  onClick={handleReset}
                >
                  Reset
                </Button> */}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Create {config.label}
                </Button>
              </Box>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default React.memo(DynamicNotificationForm);

